<template>
    <div id="app">
        <div class="bg-warning">
            <br><br><br><br>
            <img :src="logo" class="logo-left">
            <img src="./assets/logo-dc.svg" class="logo-right">
        </div>
        <br><br>

        <p v-if="loading">Cargando...</p>

        <vue-page-transition name="fade-in-right" v-if="!loading && !error">
            <router-view />
        </vue-page-transition>

        <h1 v-if="error">Evaluación inválida</h1>
    </div>
</template>

<script>
import axios from "axios";

export default {
    data() {
        return {
            loading: true,
            error: false,
            logo: null,
        };
    },
    methods: {},
    mounted() {
        let route = this.$route.path;
        route = route.substring(1);
        route = route.replace("/", "-");

        axios
            .get("https://api.tocinn.com/api/profiles/" + route)
            .then((res) => {
                this.loading = false;
                this.logo = res.data.client.logo;
            })
            .catch((err) => {
                console.log(err);
                this.error = true;
                this.loading = false;
            });
    },
};
</script>

<style>
body,
html {
    height: 100%;
}

#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    height: 100%;
}

.logo-left {
    position: absolute;
    top: 20px;
    left: 20px;
    width: 150px;
}

.logo-right {
    position: absolute;
    top: 20px;
    right: 20px;
    height: 45px;
}
</style>
